/**
 * Remembers the supplier payments filters - dates, list type (paid / due / payments) and the
 * chosen brands, domains, product types and suppliers - in this browser, so a reload (F5)
 * keeps them. Reset forgets them.
 *
 * Browser storage can be unavailable (private windows, blocked site data), so every access
 * is guarded and the page then simply starts from its defaults.
 */
const KEY = 'supplierPayments.filters.v1';

/** The filter data fields that are remembered; the lists themselves are always loaded fresh. */
const DATA_FIELDS = [
  'selectedTableType',
  'selectedProductTypes',
  'selectedBrands',
  'selectedDomains',
  'selectedSuppliers',
  'supplierSearch',
  'hideZeroSuppliers',
];

export default {
  DATA_FIELDS,

  /**
   * @param filter state.supplierPayments.filter
   */
  save(filter) {
    const data = {};
    DATA_FIELDS.forEach((field) => {
      data[field] = filter.data[field];
    });
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ date: filter.date, data }));
    } catch (e) {
      // Not remembered - the filters still work for this visit.
    }
  },

  /**
   * @returns {{date: Object, data: Object}|null}
   */
  load() {
    try {
      const saved = JSON.parse(window.localStorage.getItem(KEY));
      return saved && saved.date && saved.data ? saved : null;
    } catch (e) {
      return null;
    }
  },

  clear() {
    try {
      window.localStorage.removeItem(KEY);
    } catch (e) {
      // Nothing to forget.
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/supplier-payments-filter-storage.js